import template from './wageAdvanceCard.html';
import controller from './wageAdvanceCard.controller';
import './wageAdvanceCard.scss';

let wageAdvanceCardComponent = {
  restrict: 'E',
  bindings: {
    advance: '<',
    onCancel: '&',
    isMobileApp: '<'
  },
  template,
  controller
};

export default wageAdvanceCardComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvanceList/wageAdvanceCard/wageAdvanceCard.component.js